import { ChatMessageDto, CustomerChatSenderType } from '@orcar/common';
import dayjs from 'dayjs';

export const getDisplayTime = (
  currentMessage: ChatMessageDto,
  nextMessage: ChatMessageDto | null,
) => {
  if (!currentMessage) return '';

  const currentTime = dayjs(currentMessage.sentAt).format('HH:mm');
  if (!nextMessage) return currentTime;

  const getType = (msg: ChatMessageDto) =>
    msg.senderType === CustomerChatSenderType.CUSTOMER ? 'user' : 'agent';

  const nextTime = dayjs(nextMessage.sentAt).format('HH:mm');

  // 메시지 타입이 다르거나 시간이 다르면 시간 표시
  return getType(currentMessage) !== getType(nextMessage) ||
    currentTime !== nextTime
    ? currentTime
    : '';
};
